import { notifyContrast } from '@/utils/notification'

export const MANAGED_BY_INSTITUTE_TEXT = 'Your plan is provided by your institute.'

export const SUSPENDED_MEMBER_MESSAGE =
  "Your access is currently unavailable because your institute's plan no longer " +
  'covers your account. Please contact your institute to restore access.'

// 403 returned by subscribe / change-package / cancel for institute-sponsored members.
export function isManagedByInstituteError(err) {
  if (err?.response?.status !== 403) return false
  const data = err.response.data || {}
  const message = (data.message || '').toLowerCase()
  return data.code === 'MANAGED_BY_INSTITUTE' || message.includes('managed by your institute')
}

// 403 returned by login / refresh-token for suspended institute members.
export function isSuspendedMemberError(err) {
  if (err?.response?.status !== 403) return false
  const message = (err.response.data?.message || '').toLowerCase()
  return message.includes("institute's plan no longer covers")
}

// Notify the user if the error is a managed-by-institute error, and return true if so.
export function notifyIfManagedByInstitute(err) {
  if (!isManagedByInstituteError(err)) return false
  const message = err.response.data?.message ||
    'Your subscription is managed by your institute and cannot be changed.'
  notifyContrast('Managed by your institute', message)
  return true
}
